import { SxProps, Theme } from '@mui/material';

export const profileNavRowStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
	width: '100%',
	px: 3,
};
